type BrandNameProps = {
  light?: boolean;
};

export function BrandName({ light = false }: BrandNameProps) {
  return (
    <span className={`wordmark__name ${light ? 'wordmark__name--light' : ''}`.trim()}>
      <span className="wordmark__primary">Malev</span>
      <span className="wordmark__secondary">Studio</span>
    </span>
  );
}
